'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavbarToggle = require('react-bootstrap/lib/NavbarToggle');

var _NavbarToggle2 = _interopRequireDefault(_NavbarToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NavbarToggle2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@sketchpixy/rubix/lib/NavbarToggle.js
 ** module id = ./node_modules/@sketchpixy/rubix/lib/NavbarToggle.js
 ** module chunks = 0
 **/